import {
  OEButton,
  OEText,
  mb,
  textAlign,
} from '@openeducation/oe-it-components';
import { styled } from '@openeducation/oe-it-themes';
import React from 'react';

import { QuestionContent } from './question-content';
import { useAskQuestion } from '../../hooks/use-ask-question';

export interface AskATeacherProps {}

export const AskATeacher = () => {
  const {
    question,
    isLoadingQuestion,
    errorQuestion,
    questionsCount = 0,
    getNextQuestion,
  } = useAskQuestion();

  if (questionsCount <= 0) {
    return (
      <NextQuestionContainer>
        <OEText
          style={[mb(4), textAlign('center')]}
          fontSize={16}
          fontType="bold"
        >
          No questions pending teacher answer
        </OEText>
        <OEText style={textAlign('center')} fontSize={14}>
          There are no questions in the queue
        </OEText>
      </NextQuestionContainer>
    );
  }

  if (!question) {
    return (
      <NextQuestionContainer>
        <OEText
          style={[mb(4), textAlign('center')]}
          fontSize={16}
          fontType="bold"
        >
          Get the next question by clicking on the button below
        </OEText>
        <OEText style={[mb(32), textAlign('center')]} fontSize={14}>
          There are {questionsCount} question(s) in the queue
        </OEText>

        {!!errorQuestion && (
          <ErrorMessage style={[mb(8), textAlign('center')]} fontSize={14}>
            Error getting the next question, please try again later
          </ErrorMessage>
        )}

        <OEButton
          size="large"
          loading={isLoadingQuestion}
          onPress={() => getNextQuestion()}
        >
          Get next question
        </OEButton>
      </NextQuestionContainer>
    );
  }

  return <QuestionContent question={question} />;
};

const NextQuestionContainer = styled.View`
  min-height: 220px;
  background-color: ${({ theme }) => theme.color.lightPrimary};
  border-radius: 8px;
  align-items: center;
  justify-content: center;
`;

const ErrorMessage = styled(OEText).attrs(({ theme, color }) => ({
  color: color || theme.color.danger,
}))``;
